// extracted by mini-css-extract-plugin
export default {"modal":"_3xF8beqclazMXHj4cI4ofY"};